<template>
    <div class="task_list pt-4">
        <v-row no-gutters class="roma-pagination mb-3 d-none d-md-block">
            <div class="d-flex wrapper align-center justify-end">
                <Pagination
                    :pages="getTasks.totalPages ? getTasks.totalPages : 1"
                    :getData="actionGetTasks"
                />
            </div>
        </v-row>
        <template v-for="(task, i) in tasks">
            <TaskCard :task="task" :key="i" />
        </template>
    </div>
</template>

<script>
import TaskCard from "./TaskCard.vue";
import { mapActions, mapGetters } from "vuex";
import Pagination from "../commons/Pagination.vue";

export default {
    components: {
        TaskCard,
        Pagination
    },
    data() {
        return {
            // tasks: []
        };
    },
    computed: {
        ...mapGetters({
            getTasks: "getTasks"
        }),
        tasks() {
            return this.getTasks ? this.getTasks.content : [];
        }
    },
    methods: {
        ...mapActions({
            actionGetTasks: "actionGetTasks"
        })
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/main";

.task_list {
}
</style>
